import { render, staticRenderFns } from "./AppealsModal.vue?vue&type=template&id=fa3840aa&scoped=true"
import script from "./AppealsModal.vue?vue&type=script&lang=ts"
export * from "./AppealsModal.vue?vue&type=script&lang=ts"
import style0 from "./AppealsModal.vue?vue&type=style&index=0&id=fa3840aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3840aa",
  null
  
)

export default component.exports